<template>
<div class="tag-list">
  <div
    v-for="item in tagList"
    :key="item.id"
    :class="[item.checked ? 'item active' : 'item']"
    @click="toggleCheckTag(item.id)"
  >
    {{item.name}}
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('tag')

export default {
  name: 'TagList',
  props: {
    tagList: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  methods: {
    ...mapMutations(['toggleCheckTag']),
  }
}
</script>

<style scoped lang="less">
.tag-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  height: 313px;
  overflow: auto;
  .item {
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    margin-right: 12px;
    margin-bottom: 12px;
    background-color: #EBF1FF;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #1F5EDB;
    cursor: pointer;
  }
  .active {
    background-color: #236CFF;
    color: #fff;
  }
}
</style>
